import React from "react";
import { useSelector, useDispatch } from "react-redux";
//shared components
import MyResponsiveRadialBar from "../../../SharedComponents/RadialBar";
import { botClassificationName, classificationColors } from "components/AFP/Constants";
import BotSelectorBox from "./Shared/BotSelectorBox";

const BlockedBotThreatLevel = (props) => {
    //states
    const { botThreatsToShow, setBotThreatsToShow, setLoading } = props;
    //redux variables
    const doubleBreakdown = useSelector((state) => state.todayBotRiskDetails?.data?.todayBotClassification);
    const botClassification = useSelector((state) => state.botTypeClassification?.data?.botTypeClassification);


    const formatBotTypeData = () => {
        let botTypeTotals = {};
        for (let dates in doubleBreakdown.item) {
            for (let id in doubleBreakdown.item[dates].bot) {
                if (id !== "" && id != 0) {
                    if (botTypeTotals[id] === undefined) {
                        botTypeTotals[id] = {
                            id: parseInt(id),
                            label: botClassificationName[id],
                            value: doubleBreakdown?.item[dates]?.bot[id],
                            color: classificationColors[botClassificationName[id]]
                        };
                    } else {
                        botTypeTotals[id].value += doubleBreakdown?.item[dates]?.bot[id];
                    };
                };
            };
        };
        return Object.values(botTypeTotals).sort(function (a, b) {
            return b.value - a.value;
        });
    };
    const formattedBotTypeData = formatBotTypeData();

    console.log("formattedBotTypeData: ", formattedBotTypeData);

    
        // //Initial Render UseEffect for getting initial bot threats to show
        // React.useEffect(() => {
        //     //Get all bot types from the websiteThreatAssessment
        //     if(botThreatsToShow.size === 0) {
        //         setBotThreatsToShow(new Map(Object.values(props.websiteThreatAssessment?.item ?? {}).map(item => [item.bot_classification, true])));
        //     };       
        // }, []);


    const formatDataForRadialGraph = () => {
        const result = [{ id: "Low", data: [] }, { id: "Medium", data: [] }, { id: "High", data: [] }, { id: "Dangerous", data: [] }];

        for (let keys in formattedBotTypeData) {
            for (let data in botClassification.items) {
                for (let id in result) {
                    if (botClassification.items[data].bot_classification_id === formattedBotTypeData[keys].id) {
                        if (result[id]?.id === botClassification.items[data].risk_level) {
                            result[id].data.push({
                                x: `${botClassification.items[data].classification} (${botClassification.items[data].risk_level})`,
                                y: formattedBotTypeData[keys].value,
                                color: classificationColors[botClassification.items[data].classification]
                            })
                        };
                    };
                };
            };
        };
        return result;
    };
    const radialBarData = formatDataForRadialGraph();

     //Initial Render UseEffect for getting initial bot threats to show
    React.useEffect(() => {
        //Get all bot types from the websiteThreatAssessment
        if(botThreatsToShow.size === 0) {
            setBotThreatsToShow(new Map(radialBarData.filter(item => Array.isArray(item.data) && item.data.length > 0).map(item => [item.id, true])));
        };       
    }, []);


    
    return (
        <>
        <div className="blocked-bot-threat-level">
            <h3>Blocked Bot Threat Level</h3>
                <div className="reporting-graph-size-box" style={{width:"100%",height:"500px"}}>
                <MyResponsiveRadialBar
                    data={radialBarData}
                    legendClassName='radial-legend-section'
                    legendData={formattedBotTypeData}
                />
                </div>
                
        </div>
        
        </>
    );
};

export default BlockedBotThreatLevel;